<div class="generic-errors">
    @if(parsedErrors().message){
        <span class="error"><cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>{{parsedErrors().message}}.</span>
    } @else {
        @if(errors() && errors()?.length){
            @for (error of errors(); track $index) {
                <span class="error"><cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>{{error}}.</span>
            }
        } @else if (parsedErrors().allErrors && parsedErrors().allErrors.length) {
            @for (error of parsedErrors().allErrors; track $index) {
                <span class="error"><cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>{{error}}.</span>
            }
        } @else {
            <span class="error"><cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>{{'shared_components.parse_error_message.generic_error' | transloco}}</span>
        }
    }
</div>